import { List, Typography } from "@mui/material";
import { ingredientsFetch } from "../actions";
import SearchProductListItem from "../../Inventory/components/SearchProductListItem";
import useRequest from "api/useRequest";
import { modalHide } from "app/App/actions";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
    Modal,
    ModalTitle,
    ModalContent,
    RequestMessage,
    ModalActions,
} from "ui";
import Search from "app/Inventory/components/Search";
import trans from "helpers/trans";
import { IngredientsModel } from "../types";
import { IProduct } from "../../Products/types";
interface IIngredientsSearchModal {
    selectIngredient: Function;
    onClose: Function;
}

const IngredientsSearchModal = (props: IIngredientsSearchModal) => {
    const [data, setData] = useState([]);
    const { selectIngredient } = props;

    const dispatch = useDispatch();
    const { cancel, currentData, isError, isLoading, request, status } =
        useRequest();

    const onClose = () => {
        if (!!props.onClose) {
            props.onClose();
        }
        dispatch(modalHide("IngredientsSearchModal"));
    };

    const onChangeSearch = (value: string) => {
        if (value.length > 0) {
            request(
                ingredientsFetch({
                    params: {
                        _search: value,
                        _sort: { name: "asc" },
                    },
                })
            );
        } else {
            setData([]);
        }
    };

    const onClickIngredient = (product: IProduct) => {
        selectIngredient(data[product._idx]);
    };

    useEffect(() => {
        if (!isLoading && status === 200) {
            setData(currentData.data);
        }
    }, [currentData?.data, isLoading, status]);

    const renderContent = () => {
        if (isLoading) return null;

        if (isError)
            return status === 404 ? (
                <Typography variant="body1" sx={{ textAlign: "center", mb: 2 }}>
                    {trans(
                        "inv.ingredients.modal.ingredientsSearchModal.notFound"
                    )}
                </Typography>
            ) : (
                <RequestMessage status={status} />
            );

        return (
            <>
                {data.map((item: IngredientsModel, idx: number) => {
                    return (
                        <SearchProductListItem
                            key={`search-ingredient-${item.id}`}
                            idx={idx}
                            product={{
                                ...item.product,
                                // Add restaurant_product because this component use this key for display additional data about product
                                restaurant_product: {
                                    delivery_slip_line_numbers:
                                        item.delivery_slip_line_numbers,
                                    location_suppliers: item.location_suppliers,
                                    name: item.name,
                                    price_history: item.price_history,
                                },
                                _idx: idx,
                            }}
                            onClick={onClickIngredient}
                        />
                    );
                })}
            </>
        );
    };

    return (
        <Modal
            maxWidth="xs"
            fullWidth
            onClose={onClose}
            open
            PaperProps={{ sx: { position: "fixed", top: 0 } }}
        >
            <ModalTitle onClose={onClose}>
                {trans("inv.ingredients.modal.ingredientsSearchModal.search")}
            </ModalTitle>
            <ModalActions sx={{ px: 2, gap: 1 }}>
                <Search
                    autoFocus={true}
                    cancelRequest={cancel}
                    isLoading={isLoading}
                    placeholder={trans(
                        "inv.ingredients.modal.ingredientsSearchModal.placeholder"
                    )}
                    onChange={onChangeSearch}
                />
            </ModalActions>
            <ModalContent sx={{ py: 0, position: "relative" }}>
                <List>{renderContent()}</List>
            </ModalContent>
        </Modal>
    );
};

export default IngredientsSearchModal;
